import * as React from 'react';

import { Label } from 'office-ui-fabric-react/lib/Label';
import { ComboBox } from 'office-ui-fabric-react/lib/ComboBox';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { DatePicker  } from 'office-ui-fabric-react/lib/DatePicker';

import { Config } from './Config.js';
import { Session } from './classi/Session.js';
import { Utils } from './classi/Utils.js';

import './css/Site.css';
import './css/Fatture.css';
import './css/DatiCatastali.css';

const sessione = new Session();
const config = new Config();
const utils = new Utils();


const DayPickerStrings = config.getDayPickerStrings();
const firstDayOfWeek = config.getPrimoGiornoSettimana();

export class DatiCatastali extends React.Component {
    
    constructor()
    {
        super();
        
        this.state = {
            visualizza:'nascosto',
            visualizzaupdate:'nascosto',
            visualizzaupdateerror:'nascosto',
            divwarning:'nascosto',
            visualizzaEmail:'nascosto',
            
            POD:'',
            ID_SITO:'',
            TIPO:'',
            
            errorMessage:'',
            erroreCombo:'',
            
            _elencoprov:[],
            _elencocomuni:[],
            
            _idtipouso: ' ',
            _idprov:' ',
            _idcomune:' ',
            _desccomune:' ',
            _tipounita:' ',
            _codcatasto:' ',
            
            _sezione:' ',
            _foglio:' ',
            _subalterno:' ',
            _particella:' ',
            _particella_ext:' ',
            _particella_tipo:' ',
            
            _noncompilazione:' ',
            _datamodulo:' ',
            _firmacliente:' ',
            _email:' ',
            
            _datapicker : ''
        }
        
        this.elencotipi = [
            {'key':'1','text':'Proprietario','tipo':'elencotipi'},
            {'key':'2','text':'Usufruttuario','tipo':'elencotipi'},
            {'key':'3','text':"Titolare di altro diritto sull'immobile",'tipo':'elencotipi'},
            {'key':'4','text':"Rappresentante legale o volontario di uno degli aventi diritto indicati",'tipo':'elencotipi'}
        ];
        this.tipiunita = [
            {'key':'1','text':'Fabbricati','tipo':'tipiunita'},
            {'key':'2','text':'Terreni','tipo':'tipiunita'}
        ];
        this.tipiparticella = [
            {'key':'1','text':'Fondiaria','tipo':'tipiparticella'},
            {'key':'2','text':'Edificabile','tipo':'tipiparticella'}
        ];
        this.noncompilazione = [
            {'key':'1','text':'Immobile non accatastato','tipo':'noncompilazione'},
            {'key':'2','text':'Immobile non accatastabile','tipo':'noncompilazione'},
            {'key':'4','text':"Forniture temporanee o per usi pubblici, escluse dall'obbligo di comunicazione dei dati catastali",'tipo':'noncompilazione'},
            {'key':'5','text':'Contratti stipulati con condomini','tipo':'noncompilazione'}
        ];
        this.tipifirma = [
            {'key':'0','text':'Assente','tipo':'tipifirma'},
            {'key':'1','text':'Presente','tipo':'tipifirma'},
        ];
        
        
        this._siti = [];

        this._onChangeCombo = this._onChangeCombo.bind(this);
        this._onChangeComboDC = this._onChangeComboDC.bind(this);
        this.popolaElencoSiti = this.popolaElencoSiti.bind(this);
        this._selezionaSito = this._selezionaSito.bind(this);
        this._onSelectDataModulo = this._onSelectDataModulo.bind(this);
        this._caricaListaComuni = this._caricaListaComuni.bind(this);
        
        this._salva = this._salva.bind(this);
        
        this.popolaElencoSiti();
    }
    
    componentDidMount() {
        utils.setBoxInfoCliente();
    }
    
    _onSelectDataModulo( date: Date | null | undefined) {
        this.setState({ _datamodulo: utils._onFormatDate(date) , _datapicker:date});
    };
    
    _salva()
    {
        this.setState({visualizzaupdate:'nascosto' , visualizzaupdateerror:'nascosto'});
        
        let request = new Request( config.get("utility_salvaDatiCatastali"),{
            
            method: 'POST', mode: 'cors', credentials: "include", 
            body: JSON.stringify({
                
                // id_sito :  this.state.ID_SITO,
                id_cliente: sessione.get('id_cliente') ,
                // tipo : this.state.TIPO ,
                
                id_sito_ee : (this.state.TIPO === 'E') ? this.state.ID_SITO : null ,
                id_sito_gas : (this.state.TIPO === 'G') ? this.state.ID_SITO : null ,

                POD: this.state.POD ,
                
                uso :  this.state._idtipouso,
                // idprov : this.state._idprov,
                id_comune_catasto : this.state._idcomune,
                comune_catasto : this.state._desccomune,
                tipo_unita : this.state._tipounita,
                codice_comune_catastale : this.state._codcatasto,

                sezione : this.state._sezione,
                foglio : this.state._foglio,
                subalterno : this.state._subalterno,
                particella :this.state._particella,
                estensione_particella : this.state._particella_ext,
                tipo_particella : this.state._particella_tipo === '' ? '0' : this.state._particella_tipo,

                compilazione : this.state._noncompilazione === '' ? '0' : this.state._noncompilazione,
                data_modulo : this.state._datamodulo,
                firma_immobile : this.state._firmacliente,
                email_cliente : this.state._email
            })
        });


        if( this.state._idtipouso === '' || this.state._idtipouso === ' ' ){this.setState({visualizzaupdate:'nascosto' , visualizzaupdateerror:'updateerror centrato margin5'}); }
        else if( this.state._tipounita === '' || this.state._tipounita === ' ' ){this.setState({visualizzaupdate:'nascosto' , visualizzaupdateerror:'updateerror centrato margin5'}); }
        // else if( this.state._particella_tipo === '' ){this.setState({visualizzaupdate:'nascosto' , visualizzaupdateerror:'updateerror centrato margin5'}); }
        // else if( this.state._noncompilazione === '' ){this.setState({visualizzaupdate:'nascosto' , visualizzaupdateerror:'updateerror centrato margin5'}); }
        else if( this.state._firmacliente === '' || this.state._firmacliente === ' ' ){this.setState({visualizzaupdate:'nascosto' , visualizzaupdateerror:'updateerror centrato margin5'}); }

        else {

            fetch(request)
            .then(function(response){
                return response.json();
            }).then(function(result){

                utils.gestisciMessaggio( result );

                if (result.success) {
                    this.setState({visualizzaupdate:'updateok centrato margin5' , visualizzaupdateerror:'nascosto'});
                }
                else
                {
                    this.setState({visualizzaupdate:'nascosto' , visualizzaupdateerror:'updateerror centrato margin5'});
                }
            }.bind(this) );
        }
        
        utils.vaiAId('filtri');
    }
    
    
    _onChangeCombo( option , index, value )
    {
        let errore = '';
        if( option.key==='' ) {errore = 'POD non selezionato';}
        this.setState({POD:option.key , TIPO:option.tipo , ID_SITO:option.id_sito, erroreCombo:errore , visualizza:'nascosto' , visualizzaupdate:'nascosto' , visualizzaupdateerror:'nascosto'});
    }
    
    
    _caricaListaComuni( idprov )
    {
        
        let request = new Request( config.get("utility_caricaComuni"),{
            method: 'POST', mode: 'cors', credentials: "include", 
            body: JSON.stringify({ id_provincia : idprov })
        });

        let _c = [];

        fetch(request)
        .then(function(response){
            return response.json();
        }).then(function(result){
            utils.gestisciMessaggio( result );
            if (result.success) {
                if('data' in result && result.data !== '')
                {
                    let d = result.data;

                    for( let i =0; i < d.length ; i++ ){
                        _c.push({ 'key': d[i].ID_COMUNE , 'text':d[i].NOME , 'istat':d[i].COD_BELVEDERE  , 'tipo':'comune'});   
                    }

                    _c = utils.ordinaArrayByKey( _c , 'text' );
                    
                    this.setState({ _elencocomuni : _c });
                }
            }
        }.bind(this) );

    }
    
    _onChangeComboDC( option , index, value )
    {
        // console.log(option , index, value);
        // option  --> {key: "30", text: "SONDRIO", tipo: "provincia"}
        
        switch(option.tipo)
        {
            case 'provincia':
                this._caricaListaComuni( option.key );
                this.setState({ _idprov : option.key ,  _desccomune:'' , _idcomune:'' ,  _codcatasto:'' });
                break;
    
            case 'comune':
                this.setState({ _idcomune : option.key , _desccomune:option.text , _codcatasto:option.istat });
                break;
            case 'elencotipi':
                this.setState({ _idtipouso : option.key });
                break;
            case 'tipiunita':
                this.setState({ _tipounita : option.key });
                break;
            case 'tipiparticella':
                this.setState({ _particella_tipo : option.key });
                break;
            case 'noncompilazione':
                this.setState({ _noncompilazione : option.key });
                break;
            case 'tipifirma':
                this.setState({ _firmacliente : option.key });
                break;
            default:
                ;
        }
    }
    

    _selezionaSito()
    {
        if( this.state.POD === '')
        {
            this.setState({ visualizza:'nascosto' , divwarning:'nascosto', erroreCombo:'Sito non selezionato'});
            return;
        }

        this.setState({visualizza:'nascosto' , divwarning:'nascosto' });


        let request = new Request( config.get("anagrafica_datiCatastali"),{
            method: 'POST', mode: 'cors', credentials: "include", 
            body: JSON.stringify({
                pod: this.state.POD ,
                id_sito :  this.state.ID_SITO,
                id_cliente: sessione.get('id_cliente') ,
                tipo : this.state.TIPO
            })
        });


        fetch(request)
        .then(function(response){
            return response.json();
        }).then(function(result){
            
            utils.gestisciMessaggio( result );
            
            let _p = [];
            
            let _idtipouso= '';
            let _idprov = '';
            let _idcomune = '';
            let _tipounita = '';
            let _codcatasto = '';
            let _desccomune = '';
            
            let _sezione='';
            let _foglio='';
            let _subalterno='';
            let _particella='';
            let _particella_ext='';
            let _particella_tipo='';
            
            let _noncompilazione='';
            let _datamodulo='';
            let _firmacliente='';
            let _email='';
            
            let _datapicker='';
            
            let visualizzaEmail = 'nascosto';
            
            if (result.success) {
                
                let d = result.data;
                let _warning = 'nascosto';
                
                if('VISUALIZZA_VALIDA_DATI_CATASTALI' in d && d.VISUALIZZA_VALIDA_DATI_CATASTALI==='SI')
                {
                    visualizzaEmail='';
                }
                
                
                if(  'province_db' in d && d.province_db !== false ) {
                    for( let i =0; i < d.province_db.length ; i++ ){
                        _p.push({ 'key': d.province_db[i].ID_PROVINCIA , 'text':d.province_db[i].NOME , 'tipo':'provincia'});   
                    }
                        
                    _p = utils.ordinaArrayByKey( _p , 'text' );
                }
                
                
                if( 'dati_catastali' in d && d.dati_catastali !== false ) { 
                    
                    let dc = d.dati_catastali;
                    
                    if( 'USO' in dc && dc.USO !== null){ _idtipouso = dc.USO; }
                    if( 'ID_PROVINCIA_CATASTO' in dc && dc.ID_PROVINCIA_CATASTO !== null){ _idprov = dc.ID_PROVINCIA_CATASTO; this._caricaListaComuni( _idprov ); }
                    if( 'ID_COMUNE_CATASTO' in dc && dc.ID_COMUNE_CATASTO !== null){ _idcomune = dc.ID_COMUNE_CATASTO; }
                    if( 'TIPO_UNITA' in dc && dc.TIPO_UNITA !== null){ _tipounita = dc.TIPO_UNITA; }
                    if( 'CODICE_COMUNE_CATASTALE' in dc && dc.CODICE_COMUNE_CATASTALE !== null){ _codcatasto = dc.CODICE_COMUNE_CATASTALE; }
                    if( 'COMUNE_CATASTO' in dc && dc.COMUNE_CATASTO !== null){ _desccomune = dc.COMUNE_CATASTO; }
                            
                    if( 'SEZIONE' in dc && dc.SEZIONE !== null){ _sezione = dc.SEZIONE; }
                    if( 'FOGLIO' in dc && dc.FOGLIO !== null){ _foglio = dc.FOGLIO; }
                    if( 'SUBALTERNO' in dc && dc.SUBALTERNO !== null){ _subalterno = dc.SUBALTERNO; }
                    if( 'PARTICELLA' in dc && dc.PARTICELLA !== null){ _particella = dc.PARTICELLA; }
                    if( 'ESTENSIONE_PARTICELLA' in dc && dc.ESTENSIONE_PARTICELLA !== null){ _particella_ext = dc.ESTENSIONE_PARTICELLA; }
                    if( 'TIPO_PARTICELLA' in dc && dc.TIPO_PARTICELLA !== null){ _particella_tipo = dc.TIPO_PARTICELLA; }
                    
                    if( 'COMPILAZIONE' in dc && dc.COMPILAZIONE !== null){ _noncompilazione = dc.COMPILAZIONE; }
                    if( 'DATA_MODULO' in dc && dc.DATA_MODULO !== null){ _datamodulo = dc.DATA_MODULO; }
                    if( 'FIRMA_IMMOBILE' in dc && dc.FIRMA_IMMOBILE !== null){ _firmacliente = dc.FIRMA_IMMOBILE; }
                    if( 'EMAIL_CLIENTE' in dc && dc.EMAIL_CLIENTE !== null){ _email = dc.EMAIL_CLIENTE; }
                }
                else
                {
                    _warning = 'warning centrato margin5';
                }

                if( _datamodulo !== '' && _datamodulo !== ' ' && _datamodulo !== null )
                {
                    // mi aspetto _datamodulo   18/08/2017
                    let pz = _datamodulo.split("/");
                    if( pz.length === 3){
                        _datapicker = new Date( pz[2] , parseInt(pz[1],10)-1, pz[0] , 0, 0, 0, 0);
                    }
                }
                
                this.setState({
                    visualizza:'' ,
                    divwarning:_warning , 
                    visualizzaEmail,
                    
                    _elencoprov:_p,
                    _idtipouso,
                    _idprov,
                    _idcomune,
                    _desccomune,
                    _tipounita,
                    _codcatasto,
                    _sezione,
                    _foglio,
                    _subalterno,
                    _particella,
                    _particella_ext,
                    _particella_tipo,
                    _noncompilazione,
                    _datamodulo,
                    _firmacliente,
                    _email,
                    
                    _datapicker
                    
                });
            }
            else
            {
                this.setState({visualizza:'nascosto' , divwarning:'warning centrato margin5' });
            }
        }.bind(this) );
    }
    
    popolaElencoSiti()
    {
        var siti = sessione.get('siti');
        
        var opzioni = []
        opzioni.push({ key:'' , text:'' })
        
        if( siti !== null ){
            for( let i =0; i < siti.length ; i++ )
            {
                let testo = siti[i].POD+ ' '+( siti[i].TIPO === 'E' ? ' (EE) ' : ' (GAS) ')+' '+siti[i].INDIRIZZO_SITO+ ' '+siti[i].NOME_COMUNE;
                opzioni.push({ key:siti[i].POD , text:testo , tipo:siti[i].TIPO , id_sito: siti[i].SITO})
            }
        }
        
        this._siti = opzioni;
    }

    
    render(){
        return ( 
        
            <div id="inner-container">
                <Label className='ms-fontSize-xxl titolo-pagina'>Dati Catastali<span id='boxdettagliocliente'></span></Label>

                <a name="inizioScheda">&nbsp;</a>

                <div id='filtri'>
                    <div className='boxsearch'>
                        <label className='ms-bgColor-themePrimary ms-font-m-plus'><span>Selezionare Sito</span></label>
                        <ComboBox
                            allowFreeform={true}
                            defaultSelectedKey=""
                            autoComplete="on"
                            options={this._siti}
                            onChanged={this._onChangeCombo}
                            errorMessage={this.state.erroreCombo}
                        />
                        <p>
                        <DefaultButton className="nomargin" primary={true} text="Seleziona" onClick={this._selezionaSito} allowDisabledFocus={true} />
                        </p>
                    </div>
                </div>
                
                <div id='warningdati' className={this.state.divwarning} >Dati Non Presenti</div>
                
                <div id='updateok' className={this.state.visualizzaupdate} >Aggiornamento eseguito con successo</div>
                <div id='updateerror' className={this.state.visualizzaupdateerror} >Aggiornamento errato. Compilare tutti i campi Obbligatori richiesti!</div>
                
                <div id='scheda' className={this.state.visualizza} >
                      
                    <div>
                        <a href="#reperimento_dati_identificativi_immobili" title="Dove reperire i dati catastali" className="linknota">
                            Dove reperire i dati identificativi degli immobili - nota 1*
                        </a>
                        <ComboBox
                            label="In qualità di *(obbligatorio)" allowFreeform={true} selectedKey={this.state._idtipouso} autoComplete="on"
                            options={this.elencotipi} onChanged={this._onChangeComboDC}
                        />
                        <span className='undernote'>
                        [Indicare se Proprietario Usufruttuario Titolare di altro diritto sull'immobile Rappresentante Legale o Delegato da uno degli aventi titolo prima indicati]
                        </span>
                        <a href="#dettagli_uso_immobili" title="Tipi di utilizzo degli immobili" className="linknota spaziosinistra">Nota 2*</a>
                    </div>
                    
                    <div>
                        <ComboBox
                            label="Provincia comune catastale" selectedKey={this.state._idprov} autoComplete="on"
                            options={this.state._elencoprov} onChanged={this._onChangeComboDC}
                        />
                    </div>
                    
                    <div>
                        <ComboBox
                            label="Comune catastale" selectedKey={this.state._idcomune} autoComplete="on" text={this.state._desccomune}
                            options={this.state._elencocomuni} onChanged={this._onChangeComboDC}
                        />
                        <span className='undernote'>
                        [Indicare il comune dove è ubicato l'immobile oggetto della fornitura di energia elettrica/gas]
                        </span>
                    </div>
                    
                    <div>
                        <TextField label="Codice comune catastale" value={this.state._codcatasto} onChanged={val => this.setState({ _codcatasto: val })} />
                        <span className='undernote'>
                        	[Indicare il codice del comune dove è ubicato l'immobile oggetto della fornitura di energia elettrica/gas]
                        </span>
                    </div>
                    
                    <div>
                        <ComboBox
                            label="Tipo unità *(obbligatorio)" selectedKey={this.state._tipounita} autoComplete="on" options={this.tipiunita} onChanged={this._onChangeComboDC}
                        />
                        <span className='undernote'>
                        	[Indicare se si tratta di Fabbricato o Terreni]
                        </span>
                    </div>
                    
                    <div>
                        <TextField label="Sezione" value={this.state._sezione} onChanged={val => this.setState({ _sezione: val })} />
                    </div>
                    
                    <div>
                        <TextField label="Foglio" value={this.state._foglio} onChanged={val => this.setState({ _foglio: val })} />
                    </div>
                    
                    <div>
                        <TextField label="Subalterno" value={this.state._subalterno} onChanged={val => this.setState({ _subalterno: val })} />
                    </div>
                    
                    <div>
                        <TextField label="Particella" value={this.state._particella} onChanged={val => this.setState({ _particella: val })} />
                        <span className='undernote'>
                        	[La particella viene talvolta indicata nei rogiti anche con il nome di mappale]
                        </span>
                    </div>
                    
                    <div>
                        <TextField label="Estensione Particella" value={this.state._particella_ext} onChanged={val => this.setState({ _particella_ext: val })} />
                        <span className='undernote'>
                        [Compilare solo per gli immobili dei comuni per i quali vige il sistema del catasto tavolare indicando le quattro cifre al denominatore]
                        </span>
                    </div>
                    
                    <div>
                        <ComboBox
                            label="Tipo Particella" selectedKey={this.state._particella_tipo} autoComplete="on"
                            options={this.tipiparticella} onChanged={this._onChangeComboDC}
                        />
                        <span className='undernote'>[Compilare solo per gli immobili dei comuni per i quali vige il sistema del catasto tavolare indicando se si tratta di Fondiaria o Edificabile]</span>
                    </div>

                    <div>
                        <ComboBox
                            label="Motivo di non compilazione dati catastali" selectedKey={this.state._noncompilazione} autoComplete="on"
                            options={this.noncompilazione} onChanged={this._onChangeComboDC}
                        />
                        <a href="#immobile_non_accatastabile" title="Dettagli sulla definizione di 'immobile non accatastabile'" className="linknota">Nota 3*</a>
                    </div>

                    <div>
                        <DatePicker
                            label='Data Modulo'
                            firstDayOfWeek={firstDayOfWeek}
                            strings={DayPickerStrings}
                            placeholder="Seleziona una data"
                            dateFormat="DD-MM-YYYY"
                            
                            formatDate={utils._onFormatDate}
                            locale='it'
                            value={this.state._datapicker}
                            onSelectDate={this._onSelectDataModulo}
                            
                            className='ms-font-m-plus'
                         />
                            
                    </div>

                    <div>
                        <ComboBox
                            label="Firma Cliente *(obbligatorio)" selectedKey={this.state._firmacliente} autoComplete="on"
                            options={this.tipifirma} onChanged={this._onChangeComboDC}
                        />
                    </div>
                    
                    <div className={this.state.visualizzaEmail}>
                        <TextField label="Email" value={this.state._email} onChanged={val => this.setState({ _email: val })} />
                    </div>
                    
                    
                    <p className='bottonesalva'>
                        <DefaultButton className="nomargin" primary={true} text="SALVA" onClick={this._salva} allowDisabledFocus={true} />
                    </p>
                    
                    
                    
                    
                    
                    
                    
                    
                    <div className='elenconote'>
                        <div className='nota'>
                            <a name="reperimento_dati_identificativi_immobili">
                                <div className='blue'> Nota 1* <br/> Dove reperire i dati identificativi degli immobili </div>
                                <div>
                                    I dati da indicare sono rilevabili dal catasto edilizio urbano (per i fabbricati urbani) o dal catasto terreni (per tutti gli altri immobili diversi dai fabbricati urbani, compresi i fabbricati rurali). Tali dati sono riportati: 
                                    <ul>
                                        <li> nell'atto di acquisto o nella denuncia di successione (se l'immobile è stato ereditato);</li>
                                        <li> in una denuncia o comunicazione ICI presentata in anni precedenti; </li>
                                        <li> in un certificato catastale.</li>
                                    </ul>
                                    Casi particolari di compilazione: immobili principali ed accessori; parti condominiali.
                                    Nel caso di più unità immobiliari con autonomi identificativi catastali, collegate ad una sola utenza (es.: unica fornitura di energia elettrica che alimenta sia l'abitazione che la cantina o il garage), occorre indicare solo l'identificativo catastale dell'unità immobiliare principale (es.: appartamento). Per quanto riguarda gli immobili condominiali, occorre indicare i dati identificativi catastali dello stabile condominiale nel suo complesso, per il quale l'utenza è stata attivata unitariamente. Se, invece, nel condominio è presente l’immobile del portiere ovvero altri vani e locali condominiali non destinati al godimento comune dei condomini perché, ad esempio, concessi in locazione a terzi (es.: esercizi commerciali, garage), nella dichiarazione vanno indicati anche i dati catastali di tali immobili oltre a quelli del complesso condominiale, fino al momento in cui il conduttore non acquisisca la titolarità dell'utenza e diventi, per questo, oggetto di richiesta separata da parte del fornitore di energia elettrica. Qualora, per effetto di quanto precede, sia necessario indicare i dati catastali relativi a più immobili alimentati dalla medesima fornitura, il condominio potrà utilizzare, oltre al modulo originale, anche copie fotostatiche dello stesso (l'invio di tutti i modelli compilati dovrà però avvenire unitariamente).
                                </div>
                            </a>
                        </div>
                        
                        <a href="#inizioScheda" className="tornaincima"> Torna In Alto </a>

                        <div className='nota'>
                            <a name="dettagli_uso_immobili">
                                <div className='blue'> Nota 2* <br/> Maggiori dettagli sull'uso dell'immobile </div>
                                <div>
                                    Qualifica dell’intestatario della fornitura. Nell’apposita casella va indicato (utilizzando uno solo dei codici da 1 a 4) il titolo in base al quale si occupa l’immobile cui si riferisce l’utenza. In particolare, va riportato:
                                    <ul>
                                        <li> Proprietario se c'è coincidenza tra l'intestatario del contratto di fornitura ed il proprietario (anche pro-quota) dell'immobile </li>
                                        <li> Usufruttuario se l'intestatario della fornitura è anche titolare di un diritto di usufrutto sull'immobile </li>
                                        <li> Titolare di altro diritto sull'immobile nel caso in cui il soggetto intestatario della fornitura occupa l'immobile in virtù di un titolo diverso da quelli sopra elencati. Ad esempio, il codice 3 va utilizzato se l'intestatario della fornitura: 
                                            <ul>
                                                <li> è titolare di un diritto di abitazione (es.: coniuge superstite, ex art. 540 c.c.), d'uso, ovvero di enfiteusi; </li>
                                                <li> occupa l'immobile sulla base di un contratto di affitto o di locazione; </li>
                                                <li> detiene l'immobile in comodato (es.: immobile concesso in uso gratuito al figlio, intestatario del contratto di fornitura); </li>
                                                <li> ovvero se, in qualità di coniuge separato, è risultato assegnatario dell'abitazione familiare. </li>
                                            </ul>
                                        </li>

                                            <li> Rappresentante Legale o Delegato da uno degli aventi titolo prima indicati l'ipotesi di "rappresentante legale" ricorre, generalmente, se l'immobile è di proprietà (ovvero è comunque utilizzato sulla base di un contratto di locazione, comodato, ecc.) di un soggetto non persona fisica (società, ente, ecc.). Per "rappresentante volontario", invece, si intende il soggetto per il quale non ricorre nessuna delle ipotesi di cui ai codici precedenti e che - in mancanza di delega formale - ha sottoscritto il contratto di fornitura. </li>
                                    </ul>
                                </div>
                            </a>
                        </div>
                        
                        <a href="#inizioScheda" className="tornaincima"> Torna In Alto </a>

                        <div className='nota'>
                            <a name="immobile_non_accatastabile">
                                <div className='blue'> Nota 3* <br/> 'Immobile non accastastabile': maggiori dettagli </div>
                                <div>
                                    Immobili non accatastabili:
                                    <ul>
                                       <li> nel caso di immobili non identificati in catasto mediante un identificativo specifico, come ad es. nel caso di pozzi, vasche di irrigazione, cartelli pubblicitari, spazi pubblici per fiere o giostre.</li>
                                       <li> forniture temporanee, ecc.: nel caso di contratti di fornitura di durata inferiore al bimestre utilizzati per attività svolte temporaneamente (es.: interventi edilizi su un immobile; cantieri; durante fiere e simili). Il codice 5 va utilizzato anche nel caso di contratti di fornitura di energia elettrica per usi di illuminazione pubblica, ovvero per forniture intestate ad enti pubblici le quali siano destinate ad alimentare immobili utilizzati dagli stessi enti nell'esercizio delle proprie funzioni istituzionali (ris. Agenzia Entrate n. 214/E dell’8/8/2007).</li>
                                    </ul>
                                </div>
                            </a>
                        </div>
                        
                        <a href="#inizioScheda" className="tornaincima"> Torna In Alto </a>
                    </div>
                    
                    
                    
                    
                    
                    
                    
                </div>
                
            </div>
                
        );
    }
}

export default DatiCatastali;


// WEBPACK FOOTER //
// ./src/AcComponents/DatiCatastali.js